import { fetchToken } from "../../services/useAuth";
import { useLoginStore } from "../../../state/LoginStore";
import { useUserStore } from "../../../state/UserStore";
import { useMUITheme } from '../../../theme/ThemeProvider';
import { useAudit } from "../../useAudit";
import { useCookies } from "react-cookie";
import { generateExpDate } from "./index";
import { getDomainName } from "../../../utils/getDomainName";
import { useCallback } from "react";

export function useSetToken(
    setLoading: React.Dispatch<boolean>,
) {

    const setUserAcceptingTerms = useLoginStore(state => state.setUserAcceptingTerms);
    const setUserConfig = useUserStore(state => state.setUserConfig);
    const userConfig = useUserStore(state => state.userConfig);
    const { saveTheme, loadUserTheme } = useMUITheme();
    const { addAuditEvent } = useAudit();
    const [, setCookie] = useCookies();
    const expDate = generateExpDate();

    const setToken = useCallback((user) => {
        (async () => {
            const { jwtToken } = user?.signInUserSession?.accessToken || "";
            setLoading(true);

            const pendingTheme = localStorage.getItem("pendingThemeSave");
            console.log('DEBUG SETTOKEN: Checking for pending theme:', pendingTheme);

            if (process.env.NODE_ENV === 'production') {
                const resp = await fetchToken(user, jwtToken)
                if (resp.ok) {
                    setUserAcceptingTerms(true)
                    setUserConfig({
                        ...userConfig
                    })
                    try {
                        let themeToApply: string;

                        if (pendingTheme) {
                            console.log('DEBUG SETTOKEN: Using pending theme:', pendingTheme);
                            themeToApply = pendingTheme;
                        } else {
                            console.log('DEBUG SETTOKEN: Loading saved theme');
                            themeToApply = loadUserTheme(user.username);
                        }

                        setUserConfig({
                            ...userConfig,
                            theme: themeToApply
                        });
                        saveTheme(themeToApply, user.username);
                    } catch (error) {
                        console.warn('Failed to load theme preference: ', error);
                        const fallbackTheme = pendingTheme || 'light';
                        saveTheme(fallbackTheme, user.username);
                    }
                    await addAuditEvent(
                        "Login",
                        `${user.username} logged into CARES dashboard at ${new Date()}`,
                        new Date(),
                        undefined
                    );
                }
            } else {
                setCookie("token", `${jwtToken}`, {
                    path: "/",
                    expires: expDate,
                    sameSite: "lax",
                    domain: getDomainName(),
                });
                setUserAcceptingTerms(true)
                setUserConfig({
                    ...userConfig
                })
                try {
                    let themeToApply: string;

                    if (pendingTheme) {
                        console.log('DEBUG SETTOKEN: Using pending theme:', pendingTheme);
                        themeToApply = pendingTheme;
                    } else {
                        console.log('DEBUG SETTOKEN: Loading saved theme');
                        themeToApply = loadUserTheme(user.username);
                    }

                    setUserConfig({
                        ...userConfig,
                        theme: themeToApply
                    });
                    saveTheme(themeToApply, user.username);
                } catch (error) {
                    console.warn('Failed to load theme preference: ', error);
                    const fallbackTheme = pendingTheme || 'light';
                    saveTheme(fallbackTheme, user.username);
                }
                await addAuditEvent(
                    "Login",
                    `${user.username} logged into CARES dashboard at ${new Date()}`,
                    new Date(),
                    undefined
                );
            }
            setLoading(false);
        })()
    }, [addAuditEvent, expDate, loadUserTheme, saveTheme, setCookie, setLoading, setUserAcceptingTerms, userConfig, setUserConfig])

    return { setToken }
}